<template>
	<div class="study ">
		<div class="flex items-center mb-[38px] pb-[6px] bB-03">
			<div @click="navClick(item,index)" v-for="(item,index) in navList" :key="index"
				:class="[lang=='en'?'mr-[20px]':'mr-[34px]',type==index?'active text-[#FF0000] font-bold':'text-[#1C1F21]']"
				class="navTitle  2xl:whitespace-nowrap cursor-pointer  relative text-[16px] ">
				{{item.title}}
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: "study",
		data() {
			return {
				lang: '',
				type: 0,
				langInfo: {},
				navList: [{
						title: '', //我的视频及课件
						path: '/studyCenter/study/videosCourse?type=0'
					},
					{
						title: '', //我的试卷
						path: '/studyCenter/study/testPaper?type=1'
					},
					{
						title: '', //我的练习
						path: '/studyCenter/study/exercise?type=2'
					},
					{
						title: '', //我的错题
						path: '/studyCenter/study/wrongQuestion?type=3'
					},
					{
						title: '', //我的收藏
						path: '/studyCenter/study/collection?type=4'
					},
					{
						title: '', //我的疑问/纠错
						path: '/studyCenter/study/questionCorrect?type=5'
					}
				]
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log(to.query.type); // 获取查询参数
				// 你可以在这里处理查询参数的变化
				this.type = to.query.type
			}
		},
		mounted() {
			if (this.$route.query.type) {
				this.type = this.$route.query.type
			}
			this.lang = localStorage.getItem('lang') || 'zh'
			this.langInfo = this.$store.getters['lang/getLangList']
			console.log("langInfo===");
			console.log(this.langInfo);
			if (this.langInfo.length == 0) {
				this.getdict_data()
			} else {
				this.setNav()
			}

		},
		methods: {
			setNav() {
				this.navList[0].title = this.langInfo.study_my_vedio
				this.navList[1].title = this.langInfo.study_my_exam
				this.navList[2].title = this.langInfo.study_exercise_chapter
				this.navList[3].title = this.langInfo.study_my_wrong
				this.navList[4].title = this.langInfo.study_my_collect
				this.navList[5].title = this.langInfo.study_my_question
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.setNav()
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			navClick(item, index) {
				if (item.path) {
					if (this.$route.fullPath == item.path) {
						// 如果相同则不进行导航
						return;
					}
					this.type = index
					this.$router.push(item.path); // 使用完整路径
				}
			}
		}
	};
</script>

<style scoped>
	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 100%;
		height: 4px;
		background-color: #FF0000;
		bottom: -6px;
		left: 50%;
		transform: translateX(-50%);

	}

	.navTitle:nth-last-child(1) {
		margin-right: 0;
	}
</style>